/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import http from './driver';
import { PlayStartData, PlayService, PlayAppraise, PlayOrder } from './types/play';

export const getStart = () => http.get<PlayStartData>('play/start');
export const getUserServices = (id, silent = false) => http.get<PlayService[]>(`play/services/user-${id}`, {}, { silent });
export const postService = (engine, body) => http.post(`play/services/${engine}`, body);
export const putService = (id, body) => http.put(`play/services/detail-${id}`, body);
export const getService = (id, scene) => http.get<PlayService>(`play/services/detail-${id}`, { scene });
export const getServices = (engine, body, silent) => http.get<PlayService[]>(`play/services/${engine}`, body, { silent });
export const getAppraises = (filter, point, limit) => http.get<PlayAppraise[]>(`/play/appraises/${filter}`, { point, limit });
export const postOrder = (body, silent) => http.post('play/orders', body, { silent });
export const getOrderList = (filter, point, limit) => http.get<PlayOrder[]>(`play/orders/${filter}`, { point, limit });
export const putOrder = (id, body, silent) => http.put(`/play/orders/detail-${id}`, body, { silent });
export const getOrder = id => http.get<PlayOrder>(`/play/orders/detail-${id}`);
export const postAppraise = body => http.post('/play/appraises', body);
export const putAppraise = (id, body) => http.put(`/play/appraises/detail-${id}`, body);
export const postComplaint = body => http.post('/complaint', body);
